import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface TeamQueryDetailKeyFilter extends RequiredQueryKeyFilter {
  teamId: number;
  targetService?: string;
}

type TeamQueryListKeyFilter = RequiredQueryKeyFilter;

export const teamQueryKeys = createDefaultQueryKeysGenerator<
  TeamQueryListKeyFilter,
  TeamQueryDetailKeyFilter
>({
  keyDataType: 'teams',
});
